import { ref } from 'vue';
import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';

export const currentTheme = ref(
  LocalStorage.get(LOCAL_STORAGE_KEYS.COLOR_SCHEME) || 'auto'
);

export const setColorTheme = isOSOnDarkMode => {
  const selectedColorScheme = LocalStorage.get(LOCAL_STORAGE_KEYS.COLOR_SCHEME);
  currentTheme.value = selectedColorScheme || 'auto';

  // Logic per User Requirements:
  // 1. Non-existent, null or empty -> consider system.
  // 2. 'system' or 'auto' -> inherit from system (OS).
  // 3. 'dark' -> override with dark.
  // 4. 'light' -> override with light.

  let shouldBeDark = false;
  const isSystemMode =
    !selectedColorScheme ||
    selectedColorScheme === 'system' ||
    selectedColorScheme === 'auto';
  if (selectedColorScheme === 'dark') {
    shouldBeDark = true;
  } else if (selectedColorScheme === 'light') {
    shouldBeDark = false;
  } else if (isSystemMode) {
    shouldBeDark = isOSOnDarkMode;
  }

  if (shouldBeDark) {
    document.documentElement.classList.add('dark');
    document.documentElement.classList.add('theme-dark');
    document.documentElement.classList.remove('theme-light');
    document.body.classList.add('dark');
    document.documentElement.style.setProperty('color-scheme', 'dark');
  } else {
    document.documentElement.classList.remove('dark');
    document.documentElement.classList.remove('theme-dark');
    document.documentElement.classList.add('theme-light');
    document.body.classList.remove('dark');
    document.documentElement.style.setProperty('color-scheme', 'light');
  }
};

// Listen for storage changes (sync between tabs)
window.addEventListener('storage', e => {
  if (e.key === LOCAL_STORAGE_KEYS.COLOR_SCHEME) {
    const isOSOnDarkMode = window.matchMedia(
      '(prefers-color-scheme: dark)'
    ).matches;
    setColorTheme(isOSOnDarkMode);
  }
});
